module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-upload-image"
    }
  }, [_c('dropzone', {
    attrs: {
      "id": "vueDropzone",
      "url": _vm.url,
      "useFontAwesome": true,
      "acceptedFileTypes": "image/*",
      "showRemoveLink": false
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-986da3fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoUploadImage.vue
// module id = 3930
// module chunks = 1